module.exports = __webpack_public_path__ + "static/media/Logo__Assurant.3364a846.svg";